import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {MainScene as Scene} from './Template/MainScene'
import {Store} from '@learningblocks/protocol-redux';
import {
  getAllDataFromAirtable,
  getGlossaryListWithAirtable,
  getIndividualGlossaryItem,
  getIndividialDataFromAirtable,
} from '@learningblocks/exp-constants/lib/Utilities';
import {GlossaryProvider} from '@learningblocks/storybook-components';
//import {getContentDetails, getContentList} from './GlossaryAPI';
import './App.scss';
import '@learningblocks/protocol-constants/lib/Styles/_styles.scss';

import {CATEGORY_LIST, API_DETAILS} from './Constants';

class App extends Component {

  componentDidMount() {
      // User snap testing script
      // ------------------------
      window.onUsersnapCXLoad = function(api) { api.init();}
      const script = document.createElement("script");
      script.text = '(function() { var s = document.createElement("script"); s.type = "text/javascript"; s.async = true; s.src = "https://widget.usersnap.com/load/06b0bac8-d301-4379-a1d3-615372cfd421?onload=onUsersnapCXLoad";';
      script.text += "document.getElementsByTagName('head')[0].appendChild(s); })();";

      document.body.appendChild(script);
  }

  /**
   * Get the entire glossary list for glossary
   */
  getFullGlossaryList = () => {
    return getGlossaryListWithAirtable(
      getAllDataFromAirtable,
      API_DETAILS.URL,
      API_DETAILS.KEY
    );
  };

  /**
   * Get individual glossary item
   */
  getIndividualGlossaryItem = () =>
    getIndividualGlossaryItem(
      getIndividialDataFromAirtable,
      API_DETAILS.URL,
      API_DETAILS.KEY
    );

  render() {
    return (
      <div className='page-content wrapper'>
        <GlossaryProvider.Component
          categories={CATEGORY_LIST}
          fetchGlossaryList={this.getFullGlossaryList()}
          fetchGlossaryItem={this.getIndividualGlossaryItem()}>
          <Scene fetchGlossaryItem={this.getIndividualGlossaryItem()} />
        </GlossaryProvider.Component>
      </div>
    );
  }
}

export default Store.getState();

ReactDOM.render(
  <Provider store={Store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
